import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'routeTripList',
    initialState: {
        isRequesting: false,
        error: null,
        data: [],
        total: 0,
        searchCriteria: {},
    },
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.items,
                total: action.payload.total,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
            };
        },
        update_loss_of_flight: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        confirm_time: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        confirm_time_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        confirm_time_fail: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        confirm_no_return: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        confirm_no_return_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        confirm_no_return_fail: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        export_request: (state) => {
            return {
                ...state,
                isExporting: true,
            };
        },
        export_succeed: (state) => {
            return {
                ...state,
                isExporting: false,
            };
        },
        export_failed: (state) => {
            return {
                ...state,
                isExporting: false,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
